


//blob转base64
export function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        var a = new FileReader();
        a.onload = function (e) {
            resolve(e.target.result);
        }
        a.readAsDataURL(blob);
    })
};
// 将base64转换成file对象
export function base64toFile(dataurl, filename = 'file') {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, { type: mime })
}